import React from 'react';
import IntroAdvertisementWrapper from 'components/IntroAdvertisementWrapper';

export default function IntroAdvertisementContainer() {
  return <IntroAdvertisementWrapper />;
}
